import React, { useState } from 'react'
import { Checkbox, Form, Schema } from 'rsuite';
import { TextField } from '../../../helpers/FormControlRSuit';

const { StringType} = Schema.Types;

let model = Schema.Model({
    compania: StringType()
      .isRequired('Es necesario que estés con un mayor de edad.'),
});

export const Step1 = ({handleNext}) => {
    const [form, setform] = useState({});

    const handleSubmit = () => {
        if (!form.check()) {
            return;
        } 
        handleNext();
    }
    return (
        <div className="h-100">
            <div className="text-center">
                <i className="fa fa-map-signs fa-4x" aria-hidden="true"></i>
            </div>
            <h3 className="mt-2 text-center">¡ Aquí comienza el viaje !</h3>
            <hr/>
            <p className="mb-2 mx-auto">Hola, si eres menor de edad antes de empezar requerimos que estés acompañado de tu padre o tutor legal.</p>

            <Form
                fluid
                ref={ref => (setform(ref))}
                model={model}
            >

                <div className="row mb-5">
                    <div className="col">
                        <TextField 
                            name="compania"
                            accepter={Checkbox}
                            value={'1'}
                        >
                            Estoy en compañía de alguno de mis padres o tutores.
                        </TextField>

                    </div>
                </div>
                <button type="button" onClick={() => handleSubmit(form)} className="btn btn-primary btn-lg btn-block">Continuar</button>
            </Form>
        </div>
    )
}
